export default {
  title: 'Aftale',
  description: 'Du bliver opkrævet {{amount}} pr. måned, hvis du ikke opsiger din prøveperiode.',
  bill_at_launch_date: 'Første betaling ved lanceringsdato',
  bill_date: 'Betalingsdato: {{date}}',
  bill_date_after_launch: 'Første betalingsdato: {{days}} dage efter lancering',
  sign_agreement: 'Underskriv venligst abonnements- og restaurantdeltagelsesaftalen',
  restaurant: 'Restaurant',
  agreement:
    'Jeg accepterer <a href="{{terms_url}}" target="_blank" rel="noreferrer noopener">platformsvilkårene</a>. Jeg kan til enhver tid opsige abonnementet ved at give {{provider}} besked om opsigelsen. Abonnementet opsiges, og betalingsaftalen tilbagekaldes, så snart restauranten kontakter {{provider}} vedrørende opsigelsen via e-mail eller WhatsApp. Der vil herefter ikke blive trukket flere beløb fra restauranten. Jeg accepterer, at mit elektroniske samtykke svarer til en underskrift på dette dokument, og jeg forstår, at min elektroniske underskrift er bindende.',
};
